<app-network-indicator />
<bor-toastr />
<app-reload-banner />
<router-outlet />
